export const FETCH_INVOICE = 'FETCH_INVOICE'
export const FETCH_INVOICE_REQUEST = `${FETCH_INVOICE}_REQUEST`
export const FETCH_INVOICE_SUCCESS = `${FETCH_INVOICE}_SUCCESS`
export const FETCH_INVOICE_FAILURE = `${FETCH_INVOICE}_FAILURE`
export const FETCH_INVOICES = 'FETCH_INVOICES'
export const FETCH_INVOICES_REQUEST = `${FETCH_INVOICES}_REQUEST`
export const FETCH_INVOICES_SUCCESS = `${FETCH_INVOICES}_SUCCESS`
export const FETCH_INVOICES_FAILURE = `${FETCH_INVOICES}_FAILURE`
export const FETCH_INVOICES_END = `${FETCH_INVOICES}_END`
export const PAY_INVOICE = 'PAY_INVOICE'
export const PAY_INVOICE_REQUEST = `${PAY_INVOICE}_REQUEST`
export const PAY_INVOICE_SUCCESS = `${PAY_INVOICE}_SUCCESS`
export const PAY_INVOICE_FAILURE = `${PAY_INVOICE}_FAILURE`
export const FETCH_PAYMENT_PARAMS = 'FETCH_PAYMENT_PARAMS'
export const FETCH_PAYMENT_PARAMS_REQUEST = `${FETCH_PAYMENT_PARAMS}_REQUEST`
export const FETCH_PAYMENT_PARAMS_SUCCESS = `${FETCH_PAYMENT_PARAMS}_SUCCESS`
export const FETCH_PAYMENT_PARAMS_FAILURE = `${FETCH_PAYMENT_PARAMS}_FAILURE`
export const FETCH_PAYMENT_STATUS = 'FETCH_PAYMENT_STATUS'
export const FETCH_PAYMENT_STATUS_REQUEST = `${FETCH_PAYMENT_STATUS}_REQUEST`
export const FETCH_PAYMENT_STATUS_SUCCESS = `${FETCH_PAYMENT_STATUS}_SUCCESS`
export const FETCH_PAYMENT_STATUS_FAILURE = `${FETCH_PAYMENT_STATUS}_FAILURE`
export const CHANGE_METHOD = 'CHANGE_METHOD'
export const CHANGE_METHOD_REQUEST = `${CHANGE_METHOD}_REQUEST`
export const CHANGE_METHOD_SUCCESS = `${CHANGE_METHOD}_SUCCESS`
export const CHANGE_METHOD_FAILURE = `${CHANGE_METHOD}_FAILURE`

export const fetchInvoice = (invoiceId) => {
  return {
    type: FETCH_INVOICE_REQUEST,
    invoiceId,
  }
}

export const fetchPaymentParams = (invoiceId, method, payload) => {
  return {
    type: FETCH_PAYMENT_PARAMS_REQUEST,
    invoiceId,
    method,
    payload,
  }
}

export const fetchPaymentStatus = (invoiceId, payload) => {
  return {
    type: FETCH_PAYMENT_STATUS_REQUEST,
    invoiceId,
    payload,
  }
}

export const payInvoice = (invoiceId, payload) => {
  return {
    type: PAY_INVOICE_REQUEST,
    invoiceId,
    payload,
  }
}

export const fetchInvoices = (invoiceType, offset) => {
  return {
    type: FETCH_INVOICES_REQUEST,
    invoiceType,
    offset,
  }
}

export const changePayMethod = (invoiceId, payload) => {
  return {
    type: CHANGE_METHOD_REQUEST,
    invoiceId,
    payload,
  }
}
